import React, { useState, useEffect } from 'react';
import { analytics } from '../utils/api';
import toast from 'react-hot-toast';

const fmt = (n) => new Intl.NumberFormat('es-CO', { style:'currency', currency:'COP', maximumFractionDigits:0 }).format(n || 0);
const fmtPct = (n) => `${n >= 0 ? '+' : ''}${n}%`;
const f = { fontFamily:"'Plus Jakarta Sans',sans-serif" };

export default function AnalyticsPage() {
  const [tab, setTab] = useState('general');
  const [general, setGeneral] = useState(null);
  const [pubs, setPubs] = useState(null);
  const [days, setDays] = useState(30);
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadData(); }, [days, tab]);

  const loadData = async () => {
    setLoading(true);
    try {
      if (tab === 'general') { const res = await analytics.general(days); setGeneral(res.data); }
      else if (tab === 'publicaciones') { const res = await analytics.publicaciones(days); setPubs(res.data); }
    } catch (err) { toast.error('Error cargando analytics'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ ...f, padding:'24px 28px', background:'#f5f5ef', minHeight:'100vh' }}>

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:24 }}>
        <div>
          <h1 style={{ fontSize:24, fontWeight:800, color:'#1a1a1a', letterSpacing:'-0.5px', margin:0 }}>Analytics</h1>
          <p style={{ fontSize:13, color:'#aaa', marginTop:4 }}>Análisis de ventas y publicaciones</p>
        </div>
        <div style={{ display:'flex', gap:4, background:'#fff', border:'1px solid #e8e8e0', borderRadius:20, padding:4 }}>
          {[7,15,30].map(d => (
            <button key={d} onClick={() => setDays(d)}
              style={{ padding:'5px 14px', borderRadius:16, fontSize:11, fontWeight:700, border:'none', cursor:'pointer', fontFamily:'Plus Jakarta Sans,sans-serif',
                background: days===d ? '#1a1a1a' : 'transparent',
                color: days===d ? '#fff' : '#888' }}>
              {d}D
            </button>
          ))}
        </div>
      </div>

      <div style={{ display:'flex', gap:4, background:'#fff', border:'1px solid #e8e8e0', borderRadius:16, padding:4, marginBottom:20, width:'fit-content' }}>
        {[['general','Análisis General'],['publicaciones','Publicaciones']].map(([id,label]) => (
          <button key={id} onClick={() => setTab(id)}
            style={{ padding:'8px 18px', borderRadius:12, fontSize:12, fontWeight:700, border:'none', cursor:'pointer', fontFamily:'Plus Jakarta Sans,sans-serif',
              background: tab===id ? '#7c5ef8' : 'transparent',
              color: tab===id ? '#fff' : '#888' }}>
            {label}
          </button>
        ))}
      </div>

      {tab === 'general' && general && !loading && (
        <div>
          <div style={{ background:'linear-gradient(135deg,#7c5ef8,#a855f7)', borderRadius:18, padding:20, marginBottom:16 }}>
            <div style={{ fontSize:13, color:'rgba(255,255,255,0.7)', fontWeight:600, marginBottom:6 }}>Resumen del periodo</div>
            <div style={{ fontSize:15, color:'#fff', lineHeight:1.6 }}>
              Tus ingresos {general.cambio_ingresos >= 0 ? 'subieron' : 'bajaron'}{' '}
              <span style={{ color:'#d4f542', fontWeight:700 }}>{fmt(Math.abs(general.ingresos_brutos - general.ingresos_anteriores))}</span>
              {' '}({fmtPct(general.cambio_ingresos)}) comparado con el periodo anterior.
            </div>
          </div>

          <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:12, marginBottom:20 }}>
            {[
              ['Ingresos brutos',    fmt(general.ingresos_brutos),  fmt(general.ingresos_anteriores), general.cambio_ingresos],
              ['Cantidad de ventas', general.cantidad_ventas,        general.ventas_anteriores,        general.cambio_ventas],
            ].map(([label, val, prev, cambio]) => (
              <div key={label} style={{ background:'#fff', border:'1px solid #e8e8e0', borderRadius:18, padding:20 }}>
                <div style={{ fontSize:11, fontWeight:700, color:'#aaa', textTransform:'uppercase', letterSpacing:'.5px', marginBottom:8 }}>{label}</div>
                <div style={{ fontSize:22, fontWeight:800, color:'#1a1a1a', letterSpacing:'-0.5px' }}>{val}</div>
                <div style={{ display:'flex', alignItems:'center', gap:6, marginTop:8 }}>
                  <span style={{ fontSize:11, color:'#bbb' }}>ant: {prev}</span>
                  <span style={{ fontSize:11, fontWeight:700, padding:'2px 8px', borderRadius:20,
                    background: cambio >= 0 ? '#e8f9d4' : '#fee2e2',
                    color: cambio >= 0 ? '#3d7a00' : '#dc2626' }}>
                    {fmtPct(cambio)}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {tab === 'publicaciones' && (
        <div style={{ background:'#fff', border:'1px solid #e8e8e0', borderRadius:18, overflow:'hidden' }}>
          {loading ? (
            <div style={{ textAlign:'center', padding:60, color:'#bbb', fontSize:13 }}>Cargando publicaciones...</div>
          ) : (
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
              <thead>
                <tr style={{ borderBottom:'1px solid #f0f0e8', background:'#fafaf5' }}>
                  {['Pareto','Publicación','Ingresos','%','Ventas','Órdenes','Categoría'].map(h => (
                    <th key={h} style={{ textAlign:'left', color:'#bbb', padding:'14px 10px', fontSize:10, fontWeight:700, textTransform:'uppercase', letterSpacing:'.4px' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {(pubs || []).map(p => {
                  const paretoColor = p.pareto === 'KILLER'
                    ? { bg:'#e8f9d4', color:'#3d7a00', label:'WINNER' }
                    : p.pareto === 'POTENCIAL'
                    ? { bg:'#fff7ed', color:'#f97316', label:'POTENCIAL' }
                    : { bg:'#f5f5ef', color:'#888', label:p.pareto };
                  return (
                    <tr key={p.item_id} style={{ borderBottom:'1px solid #f8f8f4' }}>
                      <td style={{ padding:'12px 10px' }}>
                        <span style={{ padding:'2px 10px', borderRadius:20, fontSize:10, fontWeight:700, background:paretoColor.bg, color:paretoColor.color }}>{paretoColor.label}</span>
                      </td>
                      <td style={{ padding:'12px 10px' }}>
                        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                          {p.thumbnail && <img src={p.thumbnail.replace('http://','https://')} alt="" style={{ width:32, height:32, borderRadius:6, objectFit:'cover' }} onError={e => e.target.style.display='none'} />}
                          <div>
                            <div style={{ color:'#1a1a1a', fontWeight:600, maxWidth:200, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{p.title || p.item_id}</div>
                            <div style={{ color:'#bbb', fontSize:10 }}>{p.sku || p.item_id}</div>
                          </div>
                        </div>
                      </td>
                      <td style={{ padding:'12px 10px', color:'#7c5ef8', fontWeight:700 }}>{fmt(p.ingresos)}</td>
                      <td style={{ padding:'12px 10px', color:'#888' }}>{p.pct_ingresos}%</td>
                      <td style={{ padding:'12px 10px', color:'#1a1a1a', fontWeight:600 }}>{p.ventas}</td>
                      <td style={{ padding:'12px 10px', color:'#888' }}>{p.ordenes}</td>
                      <td style={{ padding:'12px 10px', color:'#bbb', fontSize:11 }}>{p.item_id}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      )}

      {tab === 'general' && loading && (
        <div style={{ textAlign:'center', padding:60, color:'#bbb', fontSize:13 }}>Cargando analytics...</div>
      )}
    </div>
  );
}
